<template>
    <v-app>
        <user-setup :dialog="dialog" :data="data" @update:dialog="dialog = $event" />  
        <user-permission :permissionDialog="permissionDialog" :userId="userId" @update:permissionDialog="permissionDialog = $event" />  
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel" >
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">User List</v-expansion-panel-title>
                            <v-expansion-panel-text> 
                                    <v-row class="py-2">
                                      
                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>


                                        <v-col md="5" cols="12">                                           
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.fullPath)"
                                                    @click="openAddUser"
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Add User
                                                </v-btn>
                                            </div>
                                        </v-col>
                                            
                                    </v-row>                   
                                    <v-data-table
                                        :headers="headers"
                                        :items="getSchema"
                                        :loading="loading"
                                        v-model:items-per-page="itemsPerPage"
                                        :search="search"
                                        :hover="true"                    
                                        density="compact">

                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>

                                        <template v-slot:item.branch.company="{ item }">
                                            {{ item.branch.company.name.length > 30 
                                                ? item.branch.company.name.slice(0, 30) + '...' 
                                                : item.branch.company.name 
                                            }}
                                        </template>
                                        <template v-slot:item.branch="{ item }">
                                            {{ item.branch.name }} 
                                        </template>
                                        <template v-slot:item.role="{ item }">
                                            <v-badge
                                                v-if="item.tag == 'superAdmin'"
                                                color="green"
                                                content="Super Admin"
                                                inline
                                            ></v-badge>
                                             <v-badge
                                                v-else
                                                color="grey-lighten-4"
                                                :content="item.role.name"
                                                inline
                                            ></v-badge>

                                        </template>

                                        <template v-slot:item.status="{ item }">
                                            <v-chip v-if="item.status == 1" color="success" size="small" class="text-capitalize">Active</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">Inactive</v-chip>     
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-icon
                                              
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="editItem(item)"
                                                v-if="$updateAccess($route.fullPath)"
                                            >
                                               mdi mdi-pencil-outline
                                            </v-icon>

                                            <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="setPermission(item.id)"
                                                title="Set Permissions"
                                                v-if="$updateAccess($route.fullPath) && item.tag != 'superAdmin'"
                                            >
                                               mdi mdi-account-key-outline
                                            </v-icon>

                                        </template>

                                    </v-data-table>             
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import userSetup from '@/components/module/administration/userManagement/userSetup.vue';
import userPermission from '@/components/module/administration/userManagement/userPermission.vue';
export default {
        components: {
            userSetup,
            userPermission
        },
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            permissionDialog: false,
            userId: {
                id: ''
            },
            data:{},
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "Name", key: "full_name",align: "left", sortable: false },
                { title: "User Name", key: "username",align: "left" ,sortable: false },
                { title: "Code", key: "code",align: "left", width: "7%", sortable: false },
                { title: "Role", key: "role",align: "left", sortable: false },
                { title: "Company", key: "branch.company",align: "left", sortable: false },
                { title: "Branch", key: "branch",align: "left", sortable: false },
                { title: "Mobile",align: "left", key: "mobile", sortable: true },
                { title: "Email",align: "left", key: "email", sortable: true },
                { title: "Remarks",align: "center", key: "remarks", sortable: true },
                { title: "Status", align: "center", key: "status", sortable: true },
                { title: "Actions", align: "center", key: "actions", sortable: false }
            ],
        }),
        watch: {
        },
        created(){
            if(this.$store.getters.getUsersList.length == 0){
                this.loading = true;
                 this.$store.dispatch('getUsersList').then((response) => {
                    this.loading = false;
                })
            };
        },
        computed:{
            getSchema() {
                return this.$store.getters.getUsersList;
            },
        },
        methods: {
            openAddUser() {
                this.data = {
                    id: '',
                    first_name: '',
                    last_name: '',
                    mobile: '',
                    email: '',
                    tagline: '',
                    logo: '',
                    remarks: '',
                    status: 1,
                    branch_id: '',
                    role_id: '',
                    branch: {
                    company_id: '',
                    },
                };
                this.dialog = true;
            },
            editItem(item){
                this.data = { ...item };
                this.dialog = true;
            },
            exportToPDF() {
                let serialNumber = 1;
                const columns = ['#SL', 'Role','Code', 'Name', 'Mobile','Email','Status'];
                const rows = this.getSchema.map(item => [serialNumber++, item.role.name, item.code, item.first_name, item.mobile, item.email, item.status == 1 ? 'Active' : 'Inactive']);
                this.$exportTableToPDF(columns,rows,'User List','user_list_' + this.$fileDate())
            },
            exportToExcel() {
                var data = [['#SL', 'Role', 'Code', 'Name', 'Mobile','Email','Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++,item.role.name, item.code, item.first_name, item.mobile, item.email, item.status == 1 ? 'Active' : 'Inactive']);
                });
                this.$exportTableToExcel(data,'user_list_' + this.$fileDate());
            },
            exportToCSV() {
                var data = [['#SL', 'Role', 'Code', 'Name', 'Mobile','Email','Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++,item.role.name, item.code, item.first_name, item.mobile, item.email, item.status == 1 ? 'Active' : 'Inactive']);
                });

                this.$exportTableToCSV(data,'user_list_' + this.$fileDate());
            },
            setPermission(id) {
                this.userId.id = id;
                this.permissionDialog = true;
            }
        },
        mounted() {
        },  
        beforeUnmount() {
            this.$store.commit("UNSET_USERS_LIST");
        }
    }
</script>